import styled from "styled-components";
import { DashboardContainer } from "pages/dashboard/dashboard.styles"

export const LoginContainer = styled(DashboardContainer)`
    margin-top: 130px;
    display: flex;
    flex-direction: column;
`;

export const LoginInnerContainer = styled.div`
    padding: 45px 0;
`;

export const LoginHeading = styled.div`
    margin: 0 0 10px 0;
    color: #1C9D87;
    font-size: 14px;
    font-family: RubikMedium;
`;

export const LoginSubHeading = styled.div`
    color: #142C1F;
    font-size: 22px;
    margin-bottom: 30px;
    font-family: RubikMedium;
`;

export const LoginToggleButton = styled.span`
    margin: 130px auto;
    text-align: center;
    font-size: 14px;
    color: #A5B5AF;
    cursor: pointer;
    font-family: RubikRegular;
`;